import { makeStyles } from "@mui/styles";

export const styles = makeStyles({
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: "#dfe6e9",
    height: "100%",
    width: "100%",
  },

  box: {
    padding: 10,
    margin: "10%",
    background: "#fff",
    width: 800,
    borderRadius: 10,
  },

  heading: {
    // fontWeight: "bold",
    fontSize: 20,
    fontFamily: "Poppins",
    letterSpacing: 1,
    padding: 10,
    cursor: "pointer",
  },

  rowStyle: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
  },
  image: {
    fontWeight: 450,
    fontSize: 20,
    padding: 10,
  },
});
